import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {encodingClothsImages} from '../cloths-mockup';

@Component({
  selector: 'app-symbols-encoding',
  templateUrl: './symbols-encoding.component.html',
  styleUrls: ['./symbols-encoding.component.css']
})
export class SymbolsEncodingComponent implements OnInit, OnChanges {

  @Input() counter: number;
  @Input() level: number;
  @Input() isGameGoodVsBad: boolean;
  @Output() isGoodEncoding = new EventEmitter<boolean>();
  @Output() currentEncoding = new EventEmitter<number[][]>();
  @Output() defectEncoding = new EventEmitter<number[]>();

  // Each array contains a part of the possible encodings of the length NumberOfEncodings
  // Each array contains encodings which are in at least 2 positions different.
  goodEncodings1: number[][];
  goodEncodings2: number[][];

  // The created encodings used in the actual exercise
  encoding: number[][];
  defectCounter = 0;
  symbolImages = ['./assets/images/encodings/square.png', './assets/images/encodings/circle.png'];
  clothsImages = encodingClothsImages;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.generateRandomExercise();
  }

  initValues() {
    this.goodEncodings1 = [[0, 0], [1, 1]];
    this.goodEncodings2 = [[0, 1], [1, 0]];
  }

  generateRandomExercise() {
    this.initValues();

    const numberOfEncodings = this.getNumberOfEncodings();
    const lengthOfEncoding = this.getLengthOfEncoding();
    const goodCoding = Math.floor((Math.random() * 2));

    this.generateAllEncodings(lengthOfEncoding);

    if (goodCoding) {
      this.encoding = this.generateGoodCoding(numberOfEncodings);
      this.isGoodEncoding.emit(true);
    } else {
      this.encoding = this.generateCoding(numberOfEncodings);
      this.isGoodEncoding.emit(false);
    }
    this.currentEncoding.emit(this.encoding);
  }

  /**
   * Returns the number of words that we want to encode
   */
  getNumberOfEncodings() {
    if (this.level === 1) {
      return 3;
    } else if (this.level === 2) {
      if (this.isGameGoodVsBad) {
        return 3;
      }
      return 4;
    } else {
      if (this.isGameGoodVsBad) {
        return 4;
      }
      return 5;
    }
  }

  /**
   * Returns the length of all the encodings.
   * The number of symbols an encodings consist of.
   */
  getLengthOfEncoding() {
    if (this.level === 1) {
      return 3;
    }  else {
      return 4;
    }
  }

  generateAllEncodings(length: number) {
    // We already have the encodings for length = 2.
    for (let i = 0; i < length - 2; i++) {
      const temp = [];
      this.cloneDeepArray(temp, this.goodEncodings1);
      this.addSymbolToEncoding(this.goodEncodings1, this.goodEncodings2);
      this.addSymbolToEncoding(this.goodEncodings2, temp);
    }
  }

  addSymbolToEncoding(mainEncoding: number[][], helperEncoding: number[][]) {
    for (let i = 0; i < mainEncoding.length; i++) {
      mainEncoding[i].push(0);
    }
    for (let j = 0; j < helperEncoding.length; j++) {
      const tmp = Object.assign([], helperEncoding[j]);
      tmp.push(1);
      mainEncoding.push(tmp);
    }
  }

  generateGoodCoding(numberOfEncodings: number) {
    const uniqueIndexes = this.getUniqueIndexes(numberOfEncodings);

    const choosedArray = Math.floor((Math.random() * 2) + 1);
    const goodCoding = [];
    for (let i = 0; i < numberOfEncodings; i++) {
      if (choosedArray === 1) {
        goodCoding[i] = this.goodEncodings1[uniqueIndexes[i]];
      } else {
        goodCoding[i] = this.goodEncodings2[uniqueIndexes[i]];
      }
    }

    return goodCoding;
  }

  generateCoding(numberOfEncodings: number) {
    const uniqueIndexes = this.getUniqueIndexes(numberOfEncodings);

    const coding = [];
    for (let i = 0; i < numberOfEncodings - 1; i++) {
      const choosedArray = Math.floor((Math.random() * 2) + 1);
      if (choosedArray === 1) {
        coding[i] = this.goodEncodings1[uniqueIndexes[i]];
      } else {
        coding[i] = this.goodEncodings2[uniqueIndexes[i]];
      }
    }

    // Make sure that it is not a good encodings!
    // Two of the encodings have only one difference.
    let counter = 0;
    let randCodingIdx;
    let randIdx;
    while (counter < 1) {
      randCodingIdx = Math.floor((Math.random() * (numberOfEncodings - 1)));
      const tempCoding = Object.assign([], coding[randCodingIdx]);
      randIdx = Math.floor((Math.random() * tempCoding.length));
      if (tempCoding[randIdx] === 0) {
        tempCoding[randIdx] = 1;
      } else {
        tempCoding[randIdx] = 0;
      }
      console.log(tempCoding);
      if (coding.findIndex(i => this.compareArrays(i, tempCoding)) === -1) {
        const randPosition = Math.floor((Math.random() * (numberOfEncodings)));
        console.log(randPosition);
        coding.splice(randPosition, 0, tempCoding);
        counter++;
      }
    }

    if (this.defectCounter < this.counter / 5) {
      this.defectCounter ++;
      const tempCoding = Object.assign([], coding[randCodingIdx]);
      tempCoding[randIdx] = -1;
      this.defectEncoding.emit(tempCoding);
    }

    return coding;
  }

  getUniqueIndexes(length: number) {
    let counter = 0;
    const idx = [];
    while (counter < length) {
      const randId = Math.floor((Math.random() * this.goodEncodings1.length));
      if (idx.indexOf(randId) === -1) {
        idx.push(randId);
        counter ++;
      }
    }

    return idx;
  }

  getSymbolImage(idx: number) {
    return this.symbolImages[idx];
  }

  getClothsImage(idx: number) {
    return this.clothsImages[idx];
  }

  cloneDeepArray(copy: number[][], original: number[][]) {
    for (let i = 0; i < original.length; i++) {
      copy[i] = Object.assign([], original[i]);
    }
  }

  getCodeWidth() {
    const width = 100 / this.encoding[0].length;
    return width.toString() + '%';
  }

  /**
   * Compare two arrays arr1 with arr2
   * Return true if both arrays are the same. (same length and same values in the same order)
   * @param arr1
   * @param arr2
   */
  compareArrays(arr1, arr2) {
    if (arr1.length !== arr2.length) {
      return false;
    }

    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) {
        return false;
      }
    }

    return true;
  }

  getGame() {
    if (this.isGameGoodVsBad) {
      return 'oneColumn';
    } else {
      return 'secondColumn';
    }
  }

}
